import { render, staticRenderFns } from "./ListaLecard.vue?vue&type=template&id=16998927&scoped=true"
import script from "./ListaLecard.vue?vue&type=script&lang=js"
export * from "./ListaLecard.vue?vue&type=script&lang=js"
import style0 from "./ListaLecard.vue?vue&type=style&index=0&id=16998927&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16998927",
  null
  
)

export default component.exports